@if (initialized) {
    <div class="grid">

        <div class="col-12">
            <bm-customer-billing-account-transaction
                    [customerBillingAccountTransactionId]="objectIdentifier.objectId"
            ></bm-customer-billing-account-transaction>
        </div>

        <div class="col-12">
            <bm-customer-billing-account
                    [customerBillingAccountId]="dto.billingAccountDtoId"
                    (onCustomerBillingAccountSelect)="handleCustomerBillingAccountSelect($event)"
            ></bm-customer-billing-account>
        </div>

        <div class="col-12">
            <bm-contract-payment
                    [customerBillingAccountId]="dto.billingAccountDtoId">
            </bm-contract-payment>
        </div>
    </div>
}